import {
    CLOSE_OVERLAY,
    FETCH_AUTOCOMPLETE_RESULTS,
    FETCH_FACETS,
    FETCH_MIDDLEFACETS,
    SHOW_RESULTS,
    FETCH_MAIN_FACETS,
    SET_INITIAL_ACTIVE_FILTERS,
    SET_SEARCH_VALUE,
    SUBMIT_SEARCH_VALUE,
    CACHE_RESPONSE,
    MAIN_FACETS_ERROR,
    SET_RESULTS_ERROR,
    UNSET_RESULTS_ERROR,
    DEACTIVATE_DEPENDENT_FACETS,
    SET_ACTIVE_FILTER_ID,
    ADD_TO_AVAILABLE_GROUPS, UPDATE_MAIN_FACETS_COUNT
} from "./ActionTypes";
import axios from "axios";
import hash from "../../Utils/hash";
import getQueryParametersFromActiveFilters from "../../Utils/getQueryParametersFromActiveFilters";
import getPageNumberFromHydraString from "../../Utils/getPageNumberFromHydraString";
import Papaparse from "papaparse";
import getApiBaseUrl from "../../Utils/getApiBaseUrl";

const apiBaseUrl = getApiBaseUrl();
const apiFacetBase = apiBaseUrl + '/search/facet?';
const apiSearchResultsBase = apiBaseUrl + '/search/result?';

export const fetchMainFacets = () => async (dispatch) => {
    let url = apiFacetBase + "facet=hovedfasett";
    try {
        const facetData = await axios.get(url, {withCredentials: true});
        const items = facetData['data']['hydra:member'];
        let mainFacets = {};
        items.forEach(item => {
            const value = item['val'];
            let id;
            let children = {};
            let middlefacets = {};
            switch (value) {
                case "Utdanninger":
                    id = 'utdanninger';
                    middlefacets['utdanningsniva'] = {
                        value: "Utdanningsnivå",
                        facetName: "utdanningsniva",
                    };
                    children['omrade'] = {
                        value: "Fylke",
                        facetName: "omrade",
                    };
                    children['sektor'] = {
                        value: "Sektor",
                        facetName: "sektor",
                    };
                    children['organisasjon'] = {
                        value: "Type lærested",
                        facetName: "organisasjon",
                    };
                    children['studieform'] = {
                        value: "Studieform",
                        facetName: "studieform",
                    };
                    break;
                case "Lærested":
                    id = 'laerested';
                    children['omrade'] = {
                        value: "Fylke",
                        facetName: "omrade",
                    };
                    children['organisasjon'] = {
                        value: "Type lærested",
                        facetName: "organisasjon",
                    };
                    children['sektor'] = {
                        value: "Sektor",
                        facetName: "sektor",
                    };
                    break;
                case "Yrker":
                    id = 'yrker';
                    children['interesse'] = {
                        value: "Interesse",
                        facetName: "interesse",
                    };
                    break;
                case "Artikler":
                    id = 'artikler';
                    children['artikkeltype'] = {
                        value: "Artikkeltype",
                        facetName: "artikkeltype",
                    };
                    break;
                case "Verktøy":
                    id = 'annet_innhold';
                    break;
                default:
                    console.error("Tried to render unknown main facet '" + value + "', please contact the administrator.");
                    id = item['val'];
                    break;
            }

            mainFacets[id] = {
                value: item['val'],
                count: item['count'],
                children: children,
                middlefacets: middlefacets,
                facetName: 'hovedfasett',
            }
        });
        const payload = {
            mainFacets: mainFacets
        };
        await dispatch({type: FETCH_MAIN_FACETS, payload: payload});
    } catch (error) {
        console.error("Request to", url, "failed", error);
        await dispatch({type: MAIN_FACETS_ERROR, payload: error});
    }
};

export const getMiddlefacetGroups = (facetName, value) => {
    switch (facetName) {

        case "utdanningsniva":
            switch (value) {
                case "Universitet og høgskole":
                    return {
                        fagomrade: {
                            value: "Fagområde",
                            facetName: "fagomrade"
                        },
                        niva: {
                            value: "Studietype",
                            facetName: "niva"
                        },
                        interesse: {
                            value: "Interesse",
                            facetName: "interesse"
                        },
                    };

                case "Annen utdanning":
                    return { };

                case "Videregående":
                    return {
                        utdanningsprogram: {
                            value: "Utdanningsprogram",
                            facetName: "utdanningsprogram"
                        },
                        niva: {
                            value: "Skoleår",
                            facetName: "niva"
                        },
                        interesse: {
                            value: "Interesse",
                            facetName: "interesse"
                        },
                    };

                case "Folkehøgskole":
                    return {
                        linje: {
                            value: "Linje",
                            facetName: "linje"
                        },
                    };

                case "Fagskole":
                    return {
                        fagretning: {
                            value: "Fagretning",
                            facetName: "fagretning"
                        },
                        niva: {
                            value: "Studietype",
                            facetName: "niva"
                        },
                    };

                case "Etter- og videreutdanning":
                case "Emne og kurs":
                    return {
                        niva: {
                            value: "Studietype",
                            facetName: "niva"
                        },
                    };

                default:
                    return {};
            }
        default:
            return {};
    }
};

const _getFacetResponseFromCache = (responseCache, url, facetName) => async (dispatch) => {
    let data;
    if (responseCache[url] !== undefined) {
        data = responseCache[url];
    }
    else {
        const APIresponse = await dispatch(_doFetchFacet(url, facetName));
        data = APIresponse.data;
        if (APIresponse.error === undefined) {
            dispatch({type: CACHE_RESPONSE, payload: {url: url, response: data}});
        }
        // @TODO: Do something if there's an error. For now the facets list is just empty.
    }
    return data;
};

const _getResultsResponseFromCache = (responseCache, url, itemsPerPage, errors) => async (dispatch) => {
    let data;
    if (responseCache[url] !== undefined) {
        data = responseCache[url];
    }
    else {
        const APIdata = await dispatch(_doFetchResults(url, itemsPerPage));
        data = APIdata;
        if (data.error === undefined) {
            if (errors.results !== undefined) {
                dispatch({type: UNSET_RESULTS_ERROR});
            }
            dispatch({type: CACHE_RESPONSE, payload: {url: url, response: data}});
        }
        else {
            dispatch({type: SET_RESULTS_ERROR, payload: {url: url, response: data}});
        }
    }
    return data;
};

const _getAutocompleteResultsResponseFromCache = (responseCache, url) => async (dispatch) => {
    let data;
    if (responseCache[url] !== undefined) {
        data = responseCache[url];
    }
    else {
        const APIdata = await dispatch(_doFetchAutocompleteResults(url));
        data = APIdata;
        if (data.error === undefined) {
            dispatch({type: CACHE_RESPONSE, payload: {url: url, response: data}});
        }
        // @TODO: Do something if there's an error. For now just keep showing "Ingen treff".
    }
    return data;
};

const _constructFacetUrl = (facetName, activeFilters) => {
    let myActiveFilters = {...activeFilters};
    let url = apiFacetBase + "facet=" + facetName;

    // When we contruct the request url for a facet, we need to include all the active filters EXCEPT the one we are
    // fetching. Or else, all the other counts will be zero.
    // Example: If we have a facet "city" with possible values Oslo (100), Trondheim (50) and Tromsø (10)
    // a selected value as a query parameter would be `city="Trondheim"`
    // This MUST be used when we fetch the values+counts for any other facet. But if it gets used here too, then the
    // result will be Oslo (0), Trondheim (50) and Tromsø (0).
    // So we need to make sure it is excluded when compiling the query parameters.
    if (myActiveFilters[facetName] !== undefined) {
        delete myActiveFilters[facetName];
    }

    let queryParameters = getQueryParametersFromActiveFilters(myActiveFilters);
    url += queryParameters;
    return url;
};

const _doFetchFacet = (url, facetName) => async () => {
    try {
        const facetData = await axios.get(url, {withCredentials: true});
        const items = facetData['data']['hydra:member'];

        let values = {};
        items.forEach(item => {

            let mval = item['val'].replace(/\W/g, '').toLowerCase();
            let myhash = hash(item['val']);
            let id = mval + "-" + myhash;

            values[id] = {
                value: item['val'],
                count: item['count'],
                facetName: facetName
            };
        });
        return {data: values};
    } catch (error) {
        console.error("Request to", url, "failed", error);
        return {
            error: error,
            data: {}
        };
    }
};

const _doFetchResults = (url, itemsPerPage) => async () => {
    try {
        const resultData = await axios.get(url, {withCredentials: true});
        const rows = resultData['data']['hydra:member'];
        const totalItems = resultData['data']['hydra:totalItems'];

        const payload = {};
        if (rows.length === 0) {
            payload.searchResults = [];
            payload.thisPage = 1;
            payload.lastPage = 1;
        }
        else {
            let searchResults = [];
            rows.forEach(row => {
                searchResults.push({
                    id: row['@id'],
                    title: row['title'],
                    type: row['type'],
                    url: row['url'],

                    entity_type_id: row['entity_type_id'],
                    image_url: row['image_url'],
                    image_title: row['image_title'],
                    image_alt: row['image_alt'],
                    description: row['description'],
                    larested: row['larested'],
                    stedsnavn: row['stedsnavn'],
                    organisasjon: row['organisasjon'],
                    utdanningsniva: row['utdanningsniva'],
                });
            });

            let thisPage, lastPage;
            if (totalItems <= itemsPerPage) {
                thisPage = 1;
                lastPage = 1;
            }
            else {
                const thisPageRaw = resultData['data']['hydra:view']['@id'];
                const lastPageRaw = resultData['data']['hydra:view']['hydra:last'];
                thisPage = getPageNumberFromHydraString(thisPageRaw);
                lastPage = getPageNumberFromHydraString(lastPageRaw);
            }

            payload.searchResults = searchResults;
            payload.thisPage = thisPage;
            payload.lastPage = lastPage;
            payload.itemsPerPage = itemsPerPage;
            payload.totalItems = totalItems;
        }
        return payload;
    } catch (error) {
        console.error("Request to", url, "failed", error);
        return {
            searchResults: [],
            thisPage: 1,
            lastPage: 1,
            error: error,
        }
    }
};

const _doFetchAutocompleteResults = (url) => async () => {
    try {
        const autocompleteResponse = await axios.get(url, {withCredentials: true});
        const myPayload = {
            acSearchResult: autocompleteResponse ? autocompleteResponse.data : null,
        };
        return myPayload;
    } catch (error) {
        console.error("Request to", url, "failed", error);
        return {
            acSearchResult: null,
            error: error,
        };
    }
};

export const fetchMiddlefacets = (responseCache, facetName, middlefacetID, activeFilters) => async (dispatch) => {
    let url = _constructFacetUrl(facetName, activeFilters);

    const payload = {
        middlefacetID: middlefacetID,
    };
    payload.values = await dispatch(_getFacetResponseFromCache(responseCache, url, facetName));

    await dispatch({type: FETCH_MIDDLEFACETS, payload: payload});
    return payload;
};

// Note:
// facetName and groupID are always the same, for now. They should have been merged to one. However, I can think of a quite
// extreme case where a facet would be "shared" in many different groups. Because of that, I kept them separate.
export const fetchFacets = (responseCache, facetName, groupID, activeFilters) => async (dispatch) => {
    let url = _constructFacetUrl(facetName, activeFilters);

    const payload = {
        groupID: groupID,
    };

    payload.values = await dispatch(_getFacetResponseFromCache(responseCache, url, facetName));

    await dispatch({type: FETCH_FACETS, payload: payload});
};

// facetName and groupID: see note on fetchFacets()
export const fetchExtraFacets = (responseCache, facetName, groupID, activeFilters, middlefacetGroupID, middlefacetID, middlefacetGroupValue) => async (dispatch) => {
    let url = _constructFacetUrl(facetName, activeFilters);

    const payload = {
        groupID: groupID,
        middlefacetGroupID: middlefacetGroupID,
        middlefacetID: middlefacetID,
        middlefacetName: facetName,
        middlefacetGroupValue: middlefacetGroupValue,
    };

    payload.values = await dispatch(_getFacetResponseFromCache(responseCache, url, facetName));

    await dispatch({type: FETCH_FACETS, payload: payload});
};

export const fetchResults = (responseCache, activeFilters, errors, initialPage = 1, itemsPerPage = 10) => async (dispatch) => {
    let url = apiSearchResultsBase;
    let queryParameters = "page=" + initialPage + "&itemsPerPage=" + itemsPerPage + getQueryParametersFromActiveFilters(activeFilters);
    url += queryParameters;

    const myPayload = await dispatch(_getResultsResponseFromCache(responseCache, url, itemsPerPage, errors));
    await dispatch({type: SHOW_RESULTS, payload: myPayload});
};

export const handleSearchValueChange = (payload) => async (dispatch) => {
    await dispatch({
        type: SET_SEARCH_VALUE,
        payload: {
            acSearchInputValue: payload,
        }
    });
};

export const populateAutoComplete = (payload) => async (dispatch) => {
    if (!payload || payload.value.length < 2) {
        return;
    }

    const url = apiSearchResultsBase + 'query_value=' + payload.value.trim();
    const myPayload = await dispatch(_getAutocompleteResultsResponseFromCache(payload.responseCache, url));
    await dispatch({type: FETCH_AUTOCOMPLETE_RESULTS, payload: myPayload});
};

export const handleSearchValueSubmit = (payload) => async (dispatch) => {
    const searchValue = payload;

    let myPayload = {
        acSearchResult: null,
        acSearchInputValue: searchValue,
        acOverlay: false
    };
    // This handles the SearchBar input.
    await dispatch({type: SET_SEARCH_VALUE, payload: myPayload});
    // This handles the search history and the search callback.
    await dispatch({type: SUBMIT_SEARCH_VALUE, payload: searchValue});
    // This will update the main facets count.
    const trimmed = searchValue.trim();
    await dispatch(updateMainFacetsCount(trimmed));
};

export const closeOverlay = () => async (dispatch) => {
    // See Note 21042020-Autocomplete, keep it for future use.
    await dispatch({type: CLOSE_OVERLAY});
};

export const _getInitialActiveFilters = () => {
    const filters = {};
    const hash = window.location.hash.split('#')[1];
    if (!hash || !hash.length) {
        return {};
    }
    const urlParams = new URLSearchParams(hash);
    for (const [key, value] of urlParams.entries()) {
        if (key === 'hovedfasett' || key === 'utdanningsniva' || key === 'query_value') {
            filters[key] = {
                value: value
            };
        }
        else {
            filters[key] = [];
            let parsed = Papaparse.parse(value, {delimiter: ","});
            let values = parsed.data[0];
            for (let i = 0; i < values.length; i++) {
                filters[key].push({value: values[i]});
            }
        }
    }
    return filters;
}

export const setInitialActiveFilters = () => async (dispatch) => {
    const filters = _getInitialActiveFilters();
    const payload = {
        filters: filters
    };
    dispatch({type: SET_INITIAL_ACTIVE_FILTERS, payload: payload})
    return filters;
};

export const updateFacets = (responseCache, facets, activeFilters) => async (dispatch) => {
    if (activeFilters.hovedfasett === undefined) {
        // This action makes sense only if there's a hovedfasett enabled.
        return;
    }

    const activeMainFacetID = activeFilters.hovedfasett.id;
    if (activeMainFacetID === undefined) {
        // This might happen if the main facet has been set directly through the window hash query parameters.
        // In that case we anyway don't have any facet lists fetched yet, so nothing to do here.
        return;
    }
    const activeMainFacet = facets[activeMainFacetID];

    // First take care of the main children.
    if (activeMainFacet.children !== undefined) {
        for (const [groupID, child] of Object.entries(activeMainFacet.children)) {
            const facetName = child.facetName;
            await dispatch(fetchFacets(responseCache, facetName, groupID, activeFilters));
        }
    }

    // Now take care of the extra children (the ones coming from middlefacets) if such exist.
    if (activeMainFacet.middlefacets !== undefined) {
        for (const [middlefacetID, middlefacet] of Object.entries(activeMainFacet.middlefacets)) {
            const middlefacetName = middlefacet.facetName;
            if (activeFilters[middlefacetName] !== undefined) {
                // This middlefacet has been used already, so possibly it has contributed with its own facets, and it affects
                // also the other facets counts.
                const middlefacetElementID = activeFilters[middlefacetName].id;
                if (middlefacetElementID) {
                    const middlefacetElement = activeMainFacet.middlefacets[middlefacetID].children[middlefacetElementID];
                    if (middlefacetElement.children !== undefined) {
                        for (const [groupID, item] of Object.entries(middlefacetElement.children)) {
                            dispatch(fetchExtraFacets(responseCache, item.facetName, groupID, activeFilters, middlefacetName, middlefacetElementID, item.value));
                        }
                    }
                }
            }
            // Now take care of the middlefacet itself.
            dispatch(fetchMiddlefacets(responseCache, middlefacetName, middlefacetID, activeFilters));
        }
    }
};

export const deactivateDependentFacets = (activeMainFacet, facetName, activeFilters, activeMainFacetID) => async (dispatch) => {
    let facetsToUnset = [];
    if (activeMainFacet.middlefacets[facetName] !== undefined) {
        const middlefacetValue = activeFilters[facetName].value;
        const groups = getMiddlefacetGroups(facetName, middlefacetValue);
        for (const [, groupItem] of Object.entries(groups)) {
            const groupFacetName = groupItem.facetName;
            facetsToUnset.push(groupFacetName);
        }
        const ftuPayload = {
            "activeMainFacetID": activeMainFacetID,
            "facetsToUnset": facetsToUnset
        };
        dispatch({type: DEACTIVATE_DEPENDENT_FACETS, payload: ftuPayload});
    }
};

export const populateActiveFiltersIDs = (activeFilters, facets, responseCache) => async (dispatch) => {
    if (activeFilters.query_value !== undefined) {
        dispatch(updateMainFacetsCount(activeFilters.query_value.value));
    }

    // If the activeFilters do not contain the hovedfasett, there's nothing to do here.
    if (activeFilters.hovedfasett === undefined) {
        return;
    }
    const activeHovedFasettValue = activeFilters.hovedfasett.value;
    // Search in the facets to locate the one with this value in hovedfasett, and get its id.
    let activeHovedFasettID = null;
    for (const [id, item] of Object.entries(facets)) {
        if (item.value === activeHovedFasettValue) {
            activeHovedFasettID = id;
        }
    }
    if (!activeHovedFasettID) {
        // This should normally never happen, but just to be safe...
        return;
    }

    // Set the id of the hovedfasett.
    dispatch({type: SET_ACTIVE_FILTER_ID, payload: {facetName: 'hovedfasett', id: activeHovedFasettID}});

    // We need to check if this facet has middle facets.
    const middlefacets = facets[activeHovedFasettID].middlefacets;
    if (Object.keys(middlefacets).length > 0) {
        // Yes, it has middlefacets. Fetch all of them.
        // @TODO no need to fetch them all, but currently we only have one main facet (Utdanninger) that only has one
        // middlefacet (utdanningsniva), so let's just fetch everything. In the future we might improve this.
        for (const [midId, midItem] of Object.entries(middlefacets)) {
            const middlefacetName = midItem.facetName;

            const middleFacets = dispatch(fetchMiddlefacets(responseCache, middlefacetName, midId, activeFilters));
            middleFacets.then(data => {
                if (activeFilters[middlefacetName] !== undefined) {
                    const middlefacetActiveFilterValue = activeFilters[middlefacetName].value;

                    // Find the id of the middlefacet that is active.
                    for (const [midActiveId, midActiveItem] of Object.entries(data.values)) {
                        if (midActiveItem.value === middlefacetActiveFilterValue) {
                            dispatch({type: SET_ACTIVE_FILTER_ID, payload: {facetName: middlefacetName, id: midActiveId}});
                            const groups = getMiddlefacetGroups(middlefacetName, middlefacetActiveFilterValue);
                            for (const [, subItem] of Object.entries(groups)) {
                                subItem.middlefacetGroupID = middlefacetName;
                                subItem.middlefacetID = midActiveId;
                                subItem.middlefacetValue = middlefacetActiveFilterValue;
                                // Fetch the middlefacet subfacets.
                                dispatch(fetchExtraFacets(responseCache, subItem.facetName, subItem.facetName, activeFilters, middlefacetName, midActiveId, middlefacetActiveFilterValue));
                            }
                            const groupsPayload = {
                                groups: groups
                            };
                            dispatch({type: ADD_TO_AVAILABLE_GROUPS, payload: groupsPayload});
                        }
                    }
                }
            });
        }
    }

    // We need to load all the facets of this main facet.
    const groups = facets[activeHovedFasettID].children;
    const groupsPayload = {
        groups: groups
    };
    dispatch({type: ADD_TO_AVAILABLE_GROUPS, payload: groupsPayload});

    // Finally, update again all facets.
    dispatch(updateFacets(responseCache, facets, activeFilters));
}

export const updateMainFacetsCount = (searchValue) => async (dispatch) => {
    let url = apiFacetBase + "facet=hovedfasett";
    if (searchValue) {
        url += '&query_value=' + searchValue;
    }
    try {
        const facetData = await axios.get(url);
        const items = facetData['data']['hydra:member'];
        let mainFacets = {};
        items.forEach(item => {
            const value = item['val'];
            const count = item['count'];
            mainFacets[value] = count;
        });
        const payload = {
            mainFacets: mainFacets
        };
        await dispatch({type: UPDATE_MAIN_FACETS_COUNT, payload: payload});
    } catch (error) {
        console.error("Request to", url, "failed", error);
        await dispatch({type: MAIN_FACETS_ERROR, payload: error});
    }
};
